import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import Dropdown from '../../Dropdown/Dropdown.js';
import '../../BaseDropdown/BaseDropdown.js';
import '../../BaseDropdown/types.js';
import '../../BaseDropdown/components/VirtualizedMenuList.js';
import '../../Dropdown/components/OptionItem.js';
import '../../Dropdown/components/Menu.js';
import 'react';
import '../../Dropdown/context/DropdownProvider.js';
import 'react-select';

const StyledDropdown = styled(Dropdown)({
    maxWidth: 160,
});
/**
 * A dropdown styled to be placed above the grid. Can be used by consumers of DataGrid.
 */
const DataGridControlDropdown = (_a) => {
    var dropdownProps = __rest(_a, []);
    return (jsx(StyledDropdown, Object.assign({ withBorder: true }, dropdownProps)));
};

export { DataGridControlDropdown as default };
//# sourceMappingURL=DataGridControlDropdown.js.map
